import React, { Fragment, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetPartnerOffering } from "../data/api";
import { PartnerOffering, Template } from "../data/partner_offering";
import { OfferingDetails as OfferingDetailsV2 } from "../offering_v2/pages/offering_details";
import { OfferingBeyondPostalMeetingRoom } from "./beyond-postal/offering_beyond_postal_meeting_room";
import { OfferingBrainEmbassyMeetingRoom } from "./brain-embassy/offering_brain-embassy_meeting_room";
import { OfferingCoalitionSpaceMeetingRoom } from "./coalition-space/offering_coalition_space_meeting_room";
import { OfferingDiwanHubMeetingRoom } from "./diwan-hub/offering_diwan_hub_meeting_room";
import { OfferingEthosSocietyMeetingRoom } from "./ethos-society/offering_ethos_society_meeting_room";
import { OfferingFoundrSpaceMeetingRoom } from "./foundrspace/offering_foundrspace_meeting_room";
import { OfferingLuminaryMeetingRoom } from "./luminary/offering_luminary_meeting_room";
import { OfferingMDotMeetingRoom } from "./mdot/offering_mdot_meeting_room";
import { OfferingMercuryCenterMeetingRoom } from "./mercury-center/offering_mercury_center_meeting_room";
import { OfferingMindspaceMeetingRoom } from "./mindspace/offering_mindspace_meeting_room";
import { OfferingMindWareHouseMeetingRoom } from "./mindwarehouse/offering_mindwarehouse_meeting_room";

import { OfferingNomadworksMeetingRoom } from "./nomadworks/offering_nomadworks_meeting_room";
import { offeringConfig } from "./offering_config";
import { OfferingRentryMeetingRoom } from "./rentry/offering_rentry_meeting_room";
import { OfferingRoomsMeetingRoom } from "./rooms/offering_rooms_meeting_room";
import { OfferingTheMalinMeetingRoom } from "./themalin/offering_themalin_meeting_room";
import { OfferingTheYardMeetingRoom } from "./theyard/offering_theyard_meeting_room";
import { OfferingTrellisMeetingRoom } from "./trellis/offering_trellis_meeting_room";
import { OfferingUrbanplaceMeetingRoom } from "./urbanplace/offering_urbanplace_meeting_room";
import { OfferingVillageWorkspacesMeetingRoom } from "./village-workspaces/offering_village_workspaces_meeting_room";
import { OfferingWerqwiseMeetingRoom } from "./werqwise/offering_werqwise_meeting_room";
import { OfferingWeWorkClassroom } from "./wework/offering_wework_classroom";
import { OfferingWeWorkDayOffice } from "./wework/offering_wework_day_office";
import { OfferingWeWorkMeetingRoom } from "./wework/offering_wework_meeting_room";
import { useAnalytics } from "../lib/analytics/analytics";
import { useLocation } from "react-router";
import { DiscountPopupProvider } from "@/core/discount_popup_provider";

interface OfferingMeetingRoomPageParams {
  offeringID: string;
}

export function OfferingGallerySpaceDetailsPage() {
  const pageParams = useParams<OfferingMeetingRoomPageParams>();
  const partnerOfferingSlug = pageParams.offeringID;
  const partnerOffering = useGetPartnerOffering(partnerOfferingSlug);
  const isUsingOfferingV2 =
    partnerOffering.template === Template.MeetingRoomV2.toString() ||
    partnerOffering.template === Template.EventSpace ||
    partnerOffering.template === Template.RoomGallery;

  return (
    <DiscountPopupProvider partnerId={partnerOffering.partner.id}>
      {isUsingOfferingV2 ? (
        <OfferingDetailsV2 partnerOffering={partnerOffering} />
      ) : (
        <OfferingDetailsV1 partnerOffering={partnerOffering} />
      )}
      <OfferingMeetingRoomPageTracker partnerOffering={partnerOffering} />
    </DiscountPopupProvider>
  );
}

function OfferingDetailsV1(props: { partnerOffering: PartnerOffering }) {
  const { slug: partnerOfferingSlug } = props.partnerOffering;

  if (partnerOfferingSlug === offeringConfig.WeWork.slugConfig.meetingRoom) {
    return <OfferingWeWorkMeetingRoom />;
  }

  if (partnerOfferingSlug === offeringConfig.WeWork.slugConfig.classroom) {
    return <OfferingWeWorkClassroom />;
  } else if (
    partnerOfferingSlug === offeringConfig.WeWork.slugConfig.dayOffice
  ) {
    return <OfferingWeWorkDayOffice />;
  } else if (
    partnerOfferingSlug === offeringConfig.Nomadworks.slugConfig.meetingRoom
  ) {
    return <OfferingNomadworksMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.Werqwise.slugConfig.meetingRoom
  ) {
    return <OfferingWerqwiseMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.Urbanplace.slugConfig.meetingRooms
  ) {
    return <OfferingUrbanplaceMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.TheMalin.slugConfig.meetingRooms
  ) {
    return <OfferingTheMalinMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.Luminary.slugConfig.meetingRooms
  ) {
    return <OfferingLuminaryMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.DiwanHub.slugConfig.meetingRooms
  ) {
    return <OfferingDiwanHubMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.MDot.slugConfig.meetingRooms
  ) {
    return <OfferingMDotMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.MercuryCenter.slugConfig.meetingRooms
  ) {
    return <OfferingMercuryCenterMeetingRoom />;
  } else if (
    partnerOfferingSlug ===
    offeringConfig.CoalitionSpace.slugConfig.meetingRooms
  ) {
    return <OfferingCoalitionSpaceMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.Rooms.slugConfig.meetingRooms
  ) {
    return <OfferingRoomsMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.TheYard.slugConfig.meetingRooms
  ) {
    return <OfferingTheYardMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.FoundrSpace.slugConfig.meetingRooms
  ) {
    return <OfferingFoundrSpaceMeetingRoom />;
  } else if (
    partnerOfferingSlug ===
    offeringConfig.BrainEmbassyNew.slugConfig.meetingRooms
  ) {
    return <OfferingBrainEmbassyMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.Mindspace.slugConfig.meetingRooms
  ) {
    return <OfferingMindspaceMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.Rentry.slugConfig.meetingRooms
  ) {
    return <OfferingRentryMeetingRoom />;
  } else if (
    partnerOfferingSlug ===
    offeringConfig.VillageWorkspaces.slugConfig.meetingRooms
  ) {
    return <OfferingVillageWorkspacesMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.MindWareHouse.slugConfig.meetingRooms
  ) {
    return <OfferingMindWareHouseMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.EthosSociety.slugConfig.meetingRooms
  ) {
    return <OfferingEthosSocietyMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.BeyondPostal.slugConfig.meetingRooms
  ) {
    return <OfferingBeyondPostalMeetingRoom />;
  } else if (
    partnerOfferingSlug === offeringConfig.Trellis.slugConfig.meetingRooms
  ) {
    return <OfferingTrellisMeetingRoom />;
  }

  return null;
}

function OfferingMeetingRoomPageTracker(props: {
  partnerOffering: PartnerOffering;
}) {
  const analytics = useAnalytics();
  const { pathname: pathName } = useLocation();
  const { template, partner } = props.partnerOffering;
  const { id, internalName, name } = partner;

  useEffect(() => {
    analytics.screen(
      "Product Detail Page View",
      {
        partnerId: id,
        partnerName: name,
        partnerInternalName: internalName,
        pageName: `Product Detail`,
        template: template,
        Source: "WL",
      },
      { onlyProviders: ["mixpanel", "customerio"] }
    );
  }, [analytics, pathName, id, name, template, internalName]);

  return <Fragment />;
}
